import React from 'react';
import { FavoriteEntityType } from '../../../utils/apollo/graphqlSchema';
import { ISelectedEntity } from '../../Builder/EntitySelection/types';
import {
  FavoriteBasicEvent,
  FavoriteField,
  FavoriteVersionEntity,
} from '../../Favorite';

interface IProps {
  schemaId: string;
  entity: ISelectedEntity;
  onRefresh: () => void;
}

const DictionaryEntityFavorite = ({ schemaId, entity, onRefresh }: IProps) => {
  if (entity.__typename === 'BasicEventValue') {
    return (
      <FavoriteBasicEvent
        schema={schemaId}
        event={{
          key: entity.value.key,
          isFavorite: entity.isFavorite,
        }}
        onRefresh={onRefresh}
      />
    );
  }

  if (entity.__typename === 'VirtualEvent') {
    return (
      <FavoriteVersionEntity
        entityType={FavoriteEntityType.VirtualEvent}
        entity={{
          id: entity.id,
          isFavorite: entity.isFavorite,
        }}
        onRefresh={onRefresh}
      />
    );
  }

  if (
    entity.__typename === 'SimpleMeasure' ||
    entity.__typename === 'CompoundMeasure'
  ) {
    return (
      <FavoriteVersionEntity
        entityType={FavoriteEntityType.Measure}
        entity={entity}
        onRefresh={onRefresh}
      />
    );
  }

  if (entity.__typename === 'Field') {
    return (
      <FavoriteField schema={schemaId} field={entity} onRefresh={onRefresh} />
    );
  }

  if (entity.__typename === 'NamedFilter') {
    return (
      <FavoriteVersionEntity
        entityType={FavoriteEntityType.Filter}
        entity={entity}
        onRefresh={onRefresh}
      />
    );
  }

  if (
    entity.__typename === 'CompoundCohort' ||
    entity.__typename === 'ExpressionCohort' ||
    entity.__typename === 'FunnelCohort' ||
    entity.__typename === 'MeasureCohort' ||
    entity.__typename === 'PerformedCohort' ||
    entity.__typename === 'RetentionCohort'
  ) {
    return (
      <FavoriteVersionEntity
        entityType={FavoriteEntityType.Cohort}
        entity={entity}
        onRefresh={onRefresh}
      />
    );
  }

  return null;
};

export default DictionaryEntityFavorite;
